import { variants, styles, TextFieldInputTheme } from '../TextFieldInputStyles.css';
import { multiVariantStyles } from './TextFieldInputVariants.css';

const TextFieldInputStableTheme: TextFieldInputTheme = {
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { TextFieldInputStableTheme };
